import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pencil, Trash2 } from "lucide-react";
import ApplyArreasModal from "../../../modals/Hrms/ApplyArreasModal";
import ApprovalArreasModal from "../../../modals/Hrms/ApprovalArreasModal";
import {
  fetchArreasDetails,
  addArreasDetails,
  updateArreasDetails,
  deleteArreasDetails,
  approveArreasDetails,
} from "../../../redux/arreasDetailsSlice";

const ArreasDetail = () => {
  const dispatch = useDispatch();
  const { arreasDetails, status, error } = useSelector((state) => state.arreasDetails);
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [editingDues, setEditingDues] = useState(null);

  useEffect(() => {
    dispatch(fetchArreasDetails());
  }, [dispatch]);

  const handleApplyDues = async (data) => {
    try {
      if (editingDues) {
    
        await dispatch(updateArreasDetails({ id: editingDues.id, updatedData: data })).unwrap();
      } else {
   
        await dispatch(addArreasDetails({ ...data, status: "Pending" })).unwrap();
      }
      setIsApplyModalOpen(false);
      setEditingDues(null);
    } catch (err) {
      console.error("Error applying arrears:", err);
    }
  };

 
  const handleDeleteDues = async (id) => {
    try {
      await dispatch(deleteArreasDetails(id)).unwrap();
    } catch (err) {
      console.error("Error deleting arrears:", err);
    }
  };


  const handleEditDues = (due) => {
    setEditingDues(due);
    setIsApplyModalOpen(true);
  };

  const handleApprove = async () => {
    try {
      if (editingDues) {
        await dispatch(approveArreasDetails(editingDues.id)).unwrap();
        setEditingDues(null);
      }
      setIsApprovalModalOpen(false);
    } catch (err) {
      console.error("Error approving arrears:", err);
    }
  };

  return (
    <div className="container mx-auto p-4 border border-[#241763]">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Session Name: March-2024</h1>
        <button
          onClick={() => setIsApplyModalOpen(true)}
          className="bg-[#241763] text-white px-4 py-2 rounded"
        >
          Apply Arreas
        </button>
      </div>
      {status === "loading" && <p>Loading...</p>}
      {status === "failed" && <p>Error: {error}</p>}
      <div className="overflow-x-auto overflow-visible">
        <div className="max-h-[70vh] overflow-x-auto overflow-y-auto">
          <table className="table-auto w-full mt-6 text-sm">
            <thead className="py-4 border-b font-bold">
              <tr>
                <th>EMP. CODE</th>
                <th>EMPLOYEE NAME</th>
                <th>DATE</th>
                <th>Monthly Salary</th>
                <th>SESSION</th>
                <th>ARREAS</th>
                <th>DESCRIPTION</th>
                <th>STATUS</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {arreasDetails.map((due) => (
                <tr key={due.id}>
                  <td>{due.employeeCode}</td>
                  <td>
                    <div>
                      <div className="font-medium">{due.employeeName}</div>
                      <div className="text-sm text-gray-500">{due.department}</div>
                    </div>
                  </td>
                  <td>{new Date(due.applyDate).toLocaleDateString()}</td>
                  <td>{due.salary}</td>
                  <td>{due.sessionName}</td>
                  <td>{due.duesAmount}</td>
                  <td>{due.description || "-"}</td>
                  <td
                    className="cursor-pointer"
                    onClick={() => {
                      setEditingDues(due);
                      setIsApprovalModalOpen(true);
                    }}
                  >
                    <span
                      className={`px-2 py-1 rounded ${
                        due.status === "Pending"
                          ? "bg-orange-100 text-orange-600"
                          : "bg-green-100 text-green-600"
                      }`}
                    >
                      {due.status}
                    </span>
                  </td>
                  <td className="space-x-2 flex items-center py-2">
                    <button
                      className="bg-[#B6A5C9]/50 text-white p-2 rounded mr-2 hover:bg-[#241763]/60 group"
                      onClick={() => handleEditDues(due)}
                    >
                      <Pencil className="text-[#241763] w-4 h-4 group-hover:text-white" />
                    </button>
                    <button
                      className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                      onClick={() => handleDeleteDues(due.id)}
                    >
                      <Trash2 className="text-[#241763] w-4 h-4 group-hover:text-white" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <ApplyArreasModal
        isOpen={isApplyModalOpen}
        onClose={() => {
          setEditingDues(null);
          setIsApplyModalOpen(false);
        }}
        onSubmit={handleApplyDues}
        initialData={editingDues}
      />
      <ApprovalArreasModal
        isOpen={isApprovalModalOpen}
        onClose={() => setIsApprovalModalOpen(false)}
        onApprove={handleApprove}
      />
    </div>
  );
};

export default ArreasDetail;